module.exports = (original)-> ({React,FormGroup,Pikaday,ImageUpload,CountryActions,ImageInsert})->
  (props)=> 
    return <div></div> if(!props.org) 
    #make it possible to return global override of component
    {id, name, address, city, state, postcode, country, email, phone, website, emaildomain, associate} = props.org
    [
      <FormGroup label="Org Logo">
        <ImageInsert width={100} src={"/images/org-logos/"+props.org.id+".jpg"} onFileDropped={(file)=> props.fileDropped(file)} />
      </FormGroup>
      <FormGroup label="Name" key="Name">
        <input type="text" className="form-control" id="name" placeholder="Organisation Name" value={name ?= ""} onChange={(e)=> props.onUpdate(id,"name",e.target.value)} />
      </FormGroup>
      <FormGroup label="Address" key="Address">
        <textarea className="form-control" rows={5} id="address" placeholder="Address" value={address ?= ""} onChange={(e)=> props.onUpdate(id,"address",e.target.value)} />
      </FormGroup>
      <FormGroup label="Postcode" key="Postcode">
        <input type="text" className="form-control" id="postcode" placeholder="Postcode" value={postcode ?= ""} onChange={(e)=> props.onUpdate(id,"postcode",e.target.value)} />
      </FormGroup>

      <FormGroup label="City" key="City">
        <input type="text" className="form-control" id="city" placeholder="City" value={city ?= ""} onChange={(e)=> props.onUpdate(id,"city",e.target.value)} />
      </FormGroup>

      
      <FormGroup label="State" key="State">
        <select className="form-control" value={state ?= ""} onChange={(e)=> props.onUpdate(id,"state",e.target.value)} id="state" placeholder="state" disabled={country!="US"} >
          <option key="nostate" value="">{if country=="US" then "Please Select" else ""}</option>
            {props.postageStates?.map (state,idx)-> <option value={state.code} key={idx}>{state.name}</option>}
        </select>
      </FormGroup>

      <FormGroup label="Country" key="country">
        <select className="form-control" value={country ?= ""} onChange={(e)=> props.onUpdate(id,"country",e.target.value)} id="country" placeholder="Country">
          <option key="nocountry" value="">Please Select</option>
            {props.countries?.map (country,idx)-> <option value={country.code} key={idx}>{country.name}</option>}
        </select>
      </FormGroup>

      <FormGroup label="Email" key="Email">
        <input type="text" className="form-control" id="email" placeholder="Email" value={email ?= ""} onChange={(e)=> props.onUpdate(id,"email",e.target.value)} />
      </FormGroup>
      <FormGroup label="Telephone" key="Telephone">
        <input type="text" className="form-control" id="phone" placeholder="Telephone" value={phone ?= ""} onChange={(e)=> props.onUpdate(id,"phone",e.target.value)} />
      </FormGroup>
      <FormGroup label="Website" key="Website">
        <input type="text" className="form-control" id="website" placeholder="Website" value={website ?= ""} onChange={(e)=> props.onUpdate(id,"website",e.target.value)} />
      </FormGroup>
      <FormGroup label="Email Domains">
        <textarea className="form-control" rows={5} id="emaildomain" placeholder="Email Domain" value={emaildomain || ""} onChange={(e)=> props.onUpdate(id,"emaildomain",e.target.value)} />
      </FormGroup>
      <FormGroup label="Associate" checkbox={true}>
        <input type="checkbox" id="associate" checked={associate || false} onChange={(e)=> props.onUpdate(id,"associate",e.target.checked)} />
      </FormGroup>
      <FormGroup label="Public" checkbox={true}>
        <input type="checkbox" id="public" checked={props.org.public || false} onChange={(e)=> props.onUpdate(id,"public",e.target.checked)} />
      </FormGroup>
    ]